import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { pick, valuesIn } from 'lodash';

import { fetchPackageOrderDetail } from 'actions/packageOrderDetail';
import { fetchPackages } from 'actions/packages';
import { packaging } from 'actions/packaging';
import { detectingOutOfStock } from 'actions/detectingOutOfStock';
import { fetchAllStockLocationsForMultipleSKUs } from 'actions/stockLocation';

import {
  omsCommand,
  clearOmsCommand,
  manuelOmsCommand,
} from 'actions/packageOmsCommand';
import { openImageModal } from 'actions/imageModal';
import MobileView from '../mobileView';
import DesktopView from '../desktopView';
import { clientCommands } from 'appConstants';
import BarcodeModal from '../modals/barcode/main';
import MiscModal from '../modals/misc';
import OutOfStockModal from '../modals/outOfStock';
import ManuelPackageModal from '../modals/manuelPackage';
import Spinner from 'theme/Spinner';
import $S from 'theme/settings';
import './style.css';
import CargoSelectionModal from '../modals/cargo';
import { fetchCargoCompanies } from 'actions/cargoCompanies';
class PackageOrderDetail extends Component {
  state = {
    barcodeModalAction: {},
    cargoSelectionModalAction: {},
    manuelPlanningAction: {},
    miscModalVisible: false,
    barcodeModalVisible: false,
    manuelPlanningModalVisible: false,
    outOfStockModalVisible: false,
    assignmentGroups: [],
    cargoSelectionModalVisible: false,
    itemInfo: {},
    barcodes: {},
    input_parameters: {},
    unit_weights: {},
  };

  componentDidMount() {
    this.getPackageOrderDetail();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      history,
      dispatch,
      packageOrderDetail,
      packaging,
      outOfStockResponse,
      packageOrderError,
      packagingError,
      outOfStockError,
      omsCommandError,
      omsCommandSuccess,
      cargoCompaniesError,
    } = this.props;
    const { orderNumber } = packageOrderDetail;
    const apiError =
      (packageOrderError &&
        prevProps.packageOrderError !== packageOrderError) ||
      (packagingError && prevProps.packagingError !== packagingError) ||
      (outOfStockError && prevProps.outOfStockError !== outOfStockError) ||
      (omsCommandError && prevProps.omsCommandError !== omsCommandError) ||
      (cargoCompaniesError &&
        prevProps.cargoCompaniesError !== cargoCompaniesError);

    if (prevProps.packageOrderDetail !== packageOrderDetail && orderNumber) {
      dispatch(fetchPackages(orderNumber));
    }
    if (prevProps.packaging !== packaging && packaging) {
      this.onActionSuccess();
    }
    if (apiError) {
      this.onActionFail();
    }
    if (
      prevProps.outOfStockResponse !== outOfStockResponse &&
      outOfStockResponse
    ) {
      if (outOfStockResponse.is_same_location) {
        const id = outOfStockResponse.package__id;
        const url = `${$R.PACKAGE_ORDER_DETAIL.path}/${id}`;
        this.redirectToCurrentRoute(url, id);
      } else {
        this.setState({
          outOfStockModalVisible: true,
        });
      }
    }

    if (
      prevProps.omsCommandSuccess !== omsCommandSuccess &&
      omsCommandSuccess
    ) {
      this.onActionSuccess();
      dispatch(clearOmsCommand());
      if ($S.redirectAfterOutOfStock && outOfStockResponse.is_same_location)
        history.goBack();
    }
    const { state: { name = '' } = {} } = packageOrderDetail;
    const { state: { name: prevName = '' } = {} } =
      prevProps.packageOrderDetail;
    if (name && prevName && name !== prevName) {
      this.setState({ barcodes: {}, unit_weights: {} });
    }
  }

  getErpCode = () => {
    const { packages } = this.props;
    if (!packages.length) return '';
    const {
      stock_location: { erp_code },
    } = packages[0];
    return erp_code;
  };

  getAllStockLocationsForMultipleSKUs = (SKUs, erpCode = this.getErpCode()) => {
    const { dispatch } = this.props;
    dispatch(fetchAllStockLocationsForMultipleSKUs(SKUs, erpCode));
  };

  redirectToCurrentRoute = (url, id) => {
    const { history } = this.props;
    history.replace(url);
    this.getPackageOrderDetail(id);
  };

  get isAnyModalOpen() {
    const modals = pick(this.state, [
      'miscModalVisible',
      'barcodeModalVisible',
      'outOfStockModalVisible',
      'cargoSelectionModalVisible',
    ]);

    return valuesIn(modals).some((modal) => modal);
  }

  openMiscModal = (itemInfo) => {
    this.setState({ itemInfo, miscModalVisible: true });
  };

  openImageModal = (image, width, height) => {
    const { dispatch } = this.props;
    dispatch(openImageModal(image, width, height));
  };

  getPackageOrderDetail(_packageOrderId) {
    const {
      match: {
        params: { packageOrderId },
      },
      dispatch,
    } = this.props;

    dispatch(fetchPackageOrderDetail(_packageOrderId || packageOrderId));
  }

  actionsMapper() {
    const {
      packageOrderDetail: { commands = [], isClickAndCollect, state },
      pendingAnyAction,
    } = this.props;
    /* enum for commands */
    const commandsById = {
      1: 'COMPLETE_PACKAGING',
      2: 'SHIP_THE_PACKAGE',
      34: 'COMPLETE_PACKAGING_WITHOUT_SHIPMENT',
      35: 'SELF_SERVICE_PACKAGE_DELIVERY_COMMAND',
      39: 'READY_FOR_PICKUP',
    };

    return commands
      .filter(({ command }) => {
        /* Check if item Waiting status */
        if (state && state.id && state.id === 35) {
          return isClickAndCollect
            ? command !== commandsById[1]
            : command !== commandsById[34];
        }
        /* Check if item Packed all items status */
        if (state.id === 40 || state.id === 43) {
          return isClickAndCollect
            ? command !== commandsById[2]
            : command === commandsById[2];
        }

        return true;
      })
      .map((serverCommand, index) => {
        const isInstoreCommand =
          serverCommand &&
          serverCommand.ui_visibility &&
          serverCommand.ui_visibility.includes('instore');

        const clientCommand = clientCommands.find(
          (_clientCommand) =>
            _clientCommand.command === serverCommand.command && isInstoreCommand
        );

        const actions = {
          ...clientCommand,
          ...(isInstoreCommand ? serverCommand : {}),
          pendingAnyAction,
        };
        return actions;
      });
  }

  openBarcodeModal = (id, selectedIds, actionParams) => {
    this.setState({
      barcodeModalVisible: true,
      barcodeModalAction: {
        id,
        selectedIds,
        actionParams,
      },
    });
  };

  manuelPlanningAction = (id, selectedIds, actionParams) => {
    this.setState({
      manuelPlanningModalVisible: true,
      manuelPlanningAction: {
        id,
        selectedIds,
        actionParams,
      },
    });
  };

  setAssignmentGroups = (assignmentGroups) => {
    this.setState({
      input_parameters: {
        assignment_groups: assignmentGroups,
      },
    });
  };

  openCargoSelectionModal = (id, selectedIds, actionParams) => {
    const { dispatch, hasCargoCompanies } = this.props;

    if (!hasCargoCompanies) {
      dispatch(fetchCargoCompanies());
    }

    this.setState({
      cargoSelectionModalVisible: true,
      cargoSelectionModalAction: {
        id,
        selectedIds,
        actionParams,
      },
    });
  };

  closeModal = () => {
    this.setState({
      barcodeModalVisible: false,
      outOfStockModalVisible: false,
      miscModalVisible: false,
      cargoSelectionModalVisible: false,
      manuelPlanningModalVisible: false,
    });
  };

  decideAction = (id, selectedIds, actionParams) => {
    const { dispatch } = this.props;
    const { command } = actionParams;
    switch (true) {
      case $S.casesToOpenBarcodeModal.includes(command):
        return this.openBarcodeModal(id, selectedIds, actionParams);
      case $S.casesToOpenCargoSelectionModal.includes(command):
        return this.openCargoSelectionModal(id, selectedIds, actionParams);
      case command === 'DETECTED_OUT_OF_STOCK_ITEM':
        return dispatch(detectingOutOfStock(id, selectedIds, actionParams));
      case command === 'ASSIGN_PACKAGE_ITEMS_MANUALLY':
        return this.manuelPlanningAction(id, selectedIds, actionParams);
      default:
        return this.omsCommand(id, selectedIds, actionParams);
    }
  };

  onActionClick = (selectedIds = [], actionParams) => {
    const {
      packageOrderDetail: { id },
    } = this.props;
    this.decideAction(id, selectedIds, actionParams);
  };

  onActionSuccess = () => {
    this.closeModal();
    message.success($ST.MESSAGE.SUCCESS);
    this.getPackageOrderDetail();
  };

  onActionFail = () => {
    message.error($ST.MESSAGE.ERROR);
    this.getPackageOrderDetail();
  };

  packaging = () => {
    const { dispatch } = this.props;
    const {
      barcodeModalAction: { id, selectedIds, actionParams },
    } = this.state;
    this.closeModal();
    dispatch(packaging(id, selectedIds, actionParams));
  };

  omsCommand = (id, selectedIds, actionParams, extraParams = {}) => {
    const { dispatch } = this.props;
    if (actionParams.command === 'ASSIGN_PACKAGE_ITEMS_MANUALLY') {
      return dispatch(
        manuelOmsCommand(id, selectedIds, {
          ...actionParams,
          input_parameters: { assignment_groups: { extraParams } },
        })
      );
    }

    dispatch(
      omsCommand(id, selectedIds, {
        ...actionParams,
        inputParameters: extraParams,
      })
    );
  };

  setBarcode = (id, barcode) => {
    this.setState(({ barcodes }) => ({
      barcodes: { ...barcodes, [id]: barcode },
    }));
  };

  setWeight = (id, unit_weight) => {
    this.setState(({ unit_weights }) => ({
      unit_weights: {
        ...unit_weights,
        [id]: { unit_weight, package_item: id },
      },
    }));
  };

  getUntouchedWeightInputs = () => {
    const {
      packageOrderDetail: { packageItemSet },
    } = this.props;
    let newObj = {};
    packageItemSet
      .filter((packageItem) =>
        Boolean(packageItem.orderItem.attributes.unit_weight)
      )
      .forEach((item) => {
        const {
          orderItem: {
            attributes: { unit_weight },
          },
          id,
        } = item;
        newObj[id] = { unit_weight: Number(unit_weight), package_item: id };
      });
    return newObj;
  };

  render() {
    const {
      packageOrderDetail,
      pending,
      pendingAnyAction,
      cargoCompanies,
      outOfStockResponse: {
        package__stock_location__name: stockLocationName,
        package__number: packageNumber,
      },
      detectingOutOfStockPending,
      locations,
      packages,
      history,
      dispatch,
    } = this.props;
    const {
      barcodeModalVisible,
      barcodeModalAction,
      manuelPlanningAction,
      manuelPlanningModalVisible,
      outOfStockModalVisible,
      miscModalVisible,
      cargoSelectionModalVisible,
      cargoSelectionModalAction,
      itemInfo: { orderItem },
      unit_weights,
    } = this.state;
    const { packageItemSet } = packageOrderDetail;

    return (
      <Fragment>
        {(!pending || this.isAnyModalOpen) &&
          ($S.isPackageOrderDetailMobileView ? (
            <MobileView
              onActionClick={this.onActionClick}
              actionButtons={this.actionsMapper()}
              onOpenImageModal={this.openImageModal}
              pendingAnyAction={pendingAnyAction}
              packageOrder={packageOrderDetail}
            />
          ) : (
            <DesktopView
              onActionClick={this.onActionClick}
              actionButtons={this.actionsMapper()}
              onOpenImageModal={this.openImageModal}
              onOpenMiscModal={this.openMiscModal}
              packageOrder={packageOrderDetail}
              packages={packages}
            />
          ))}
        {(pending || detectingOutOfStockPending) && <Spinner centerOfPage />}
        {packageItemSet && barcodeModalVisible && barcodeModalAction && (
          <BarcodeModal
            visible
            packageItemSet={packageItemSet}
            pendingAnyAction={pendingAnyAction}
            actionData={barcodeModalAction}
            onClose={this.closeModal}
            packageOrder={packageOrderDetail}
            barcodes={this.state.barcodes}
            setBarcode={this.setBarcode}
            setWeight={this.setWeight}
            onActionFire={(actionData = {}, barcodes = []) => {
              const { id, selectedIds, actionParams } = actionData;
              const defaultInputWeights = this.getUntouchedWeightInputs();
              const unitWeights = { ...defaultInputWeights, ...unit_weights };
              const mappedUnitWeights = Object.keys(unitWeights)
                .map((key) => unitWeights[key])
                .filter((item) => Boolean(item.unit_weight));

              const isPackagingCommand =
                (actionParams.id === 1 ||
                  actionParams.command === 'PKG_STATE_TRANSITION') &&
                mappedUnitWeights.length;
              this.omsCommand(id, selectedIds, actionParams, {
                barcodes,
                ...(isPackagingCommand
                  ? { unit_weights: mappedUnitWeights }
                  : {}),
              });
            }}
          />
        )}
        {packageItemSet &&
          cargoSelectionModalVisible &&
          cargoSelectionModalAction && (
            <CargoSelectionModal
              visible
              companies={cargoCompanies}
              pendingAnyAction={pendingAnyAction}
              actionData={cargoSelectionModalAction}
              onClose={this.closeModal}
              onActionFire={(actionData = {}, extraData = {}) => {
                const { id, selectedIds, actionParams } = actionData;
                this.omsCommand(id, selectedIds, actionParams, extraData);
              }}
            />
          )}
        {outOfStockModalVisible && (
          <OutOfStockModal
            visible
            history={history}
            stockLocationName={stockLocationName}
            packageNumber={packageNumber}
          />
        )}
        {packageOrderDetail && packageItemSet && manuelPlanningModalVisible && (
          <ManuelPackageModal
            packageItemSet={packageItemSet}
            onActionFire={(actionData = {}, extraData = {}) => {
              const { id, selectedIds, actionParams } = actionData;
              dispatch(
                manuelOmsCommand(id, selectedIds, actionParams, extraData)
              );
            }}
            packageOrder={packageOrderDetail}
            visible
            onClose={this.closeModal}
            history={history}
            actionData={manuelPlanningAction}
            stockLocations={locations}
            packageNumber={packageNumber}
            setAssignmentGroups={this.setAssignmentGroups}
            getAllStockLocationsForMultipleSKUs={
              this.getAllStockLocationsForMultipleSKUs
            }
          />
        )}
        {miscModalVisible && (
          <MiscModal visible onClose={this.closeModal} orderItem={orderItem} />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    packages: state.packages.packages,
    pending: state.packages.pending || state.packageOrderDetail.pending,
    packageOrderDetail: state.packageOrderDetail.packageOrderDetail,
    packaging: state.packaging.packaging,
    locations: state.stockLocation.allStockLocations,
    packagingError: state.packaging.error.apiError,
    outOfStockResponse: state.detectingOutOfStock.detectingOutOfStockResponse,
    outOfStockError: state.detectingOutOfStock.error.apiError,
    omsCommandSuccess: state.packageOmsCommand.success,
    omsCommandError: state.packageOmsCommand.error.apiError,
    pendingAnyAction:
      state.packaging.pending ||
      state.detectingOutOfStock.pending ||
      state.packageOmsCommand.pending ||
      state.cargoCompanies.pending,
    packageOrderError: state.packageOrderDetail.error.apiError,
    hasCargoCompanies: state.cargoCompanies.loaded,
    cargoCompaniesError: state.cargoCompanies.error,
    cargoCompanies: state.cargoCompanies.cargoCompanies,
    detectingOutOfStockPending: state.detectingOutOfStock.pending,
  };
};

export default connect(mapStateToProps)(PackageOrderDetail);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/main/index.js